import { createSelector } from '@reduxjs/toolkit';

export const selectForm = (state) => state.statements.form;
export const selectParams = (state) => state.statements.params;
export const selectData = (state) => state.statements.data;
export const selectError = (state) => state.statements.error;
export const selectFetchCounter = (state) => state.statements.fetchCounter;
export const selectLoading = (state) => Boolean(state.statements.loading);
export const selectUploading = (state) => state.statements.uploading;
export const selectUpdating = (state) => state.statements.updating;
export const selectDownloading = (state) => state.statements.downloading;
export const selectDeleting = (state) => state.statements.deleting;

export const selectStatementById = (segmentId) =>
  createSelector([selectData], (data) => {
    return data?.elements?.find(({ id }) => id === segmentId);
  });
